import { defineMessages } from 'react-intl-next';

export const messages: {
	colorPickerTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	colorPickerTitle: {
		id: 'companyHub.editor.textColor.pickerTitle',
		description: 'Header of color picker dropdown for customizing text color of Company Hub',
		defaultMessage: 'Text Color',
	},
});
